import React, {createElement, useEffect, useState} from 'react'
import {Link, useLocation} from 'react-router-dom'
import 'react-loading-skeleton/dist/skeleton.css'
import {useDispatch, useSelector} from 'react-redux/es'
import {setAllCategory} from '../../../store/ViewAll/categorySlice'
import {
    useUserAllCategoryMutation,
    useUserAllCategoryIdMutation,
} from '../../../store/user/actions'
import {sendAnalytics} from '../../../utils/analytics'
import {Helmet} from 'react-helmet'
import {useScroll} from '../../../providers/scrollProvider'
import {CategoryComponent} from '../../component/Home/CategoryComponent'
import TimepassInfoBanner from "../../component/Banner/TimepassInfoBanner";
import TopGames from "../../component/Game/TopGames";
import Shimmer from "../../../components/shimmer";
import {ContinuePlayingComponent} from "../../component/ContinuePlaying";
import Ad2 from "../../../components/ads/Ad2";
import ErrorPage from "../ErrorPage/ErrorPage";

const Home = () => {
    const dispatch = useDispatch()
    const games = useSelector(state => state.games)
    const loginState = useSelector(state => state.login)
    const allCategory = useSelector(state => state.allCategory)
    const [error, setError] = useState(null)
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const access_token = searchParams.get("_portalToken")

    const [userAllCategoryId] = useUserAllCategoryIdMutation()
    const [userAllCategory] = useUserAllCategoryMutation()
    const {
        scrollHomepageForNotLoggedInUser,
        setScrollHomepageForNotLoggedInUser,
        setScrollHomePageForLoggedInUser,
    } = useScroll()

    const [firstTimeLoading, setFirstTimeLoading] = useState(true);

    const [continueGames, setContinueGames] = useState([])
    
    // Helper function to get user ID from various parameter name variations
    const getUserIdFromParams = () => {
        return searchParams.get('user-id') || 
               searchParams.get('User-id') || 
               searchParams.get('user_id') || 
               searchParams.get('User_id') || 
               searchParams.get('userId') || 
               searchParams.get('UserId') || 
               '';
    }
    
    useEffect(() => {
        const savedGames = JSON.parse(localStorage.getItem('continueGames')) || []
        setContinueGames(savedGames.reverse())
    }, [])


    const getAllCategoryId = async () => {
        try {
            const res = await userAllCategoryId({access_token}).unwrap()
            const allCategories = res?.categories?.reduce(
                (acc, val) => (acc ? [...acc, val?.uuid] : [val?.uuid]),
                []
            )
            setFirstTimeLoading(false)
            return allCategories
        } catch (error) {
            console.log(error)
            setError(error.data.message)
        }
    }

    const fetchSingleCategory = async (categoryId, page) => {
        try {
            const res = await userAllCategory({
                categoryId,
                page,
                access_token
            }).unwrap()
            return res
        } catch (error) {
            console.error(error)
        }
    }

    const [isAllCategoriesLoading, setIsAllCategoriesLoading] =
        useState(true)

    const fetchCategories = async categories => {
        setIsAllCategoriesLoading(true)
        for (const categoryId of categories) {
            try {
                const res = await fetchSingleCategory(categoryId, 1)
                if (res?.results?.games?.length > 0) {
                    dispatch(setAllCategory(res))
                }
            } catch (error) {
                console.log(error)
            }
        }
        setIsAllCategoriesLoading(false)
    }

    useEffect(() => {
        const userId = getUserIdFromParams();
        if (userId) {
            sendAnalytics('identify', {}, userId, ['mixpanel'])
        }
    }, [location])

    const handleAllGamesClicked = async (game_name, uid, updatedAt) => {
        const properties = {
            GAME_NAME: game_name,
            GAME_FROM: 'Home',
            GAME_UUID: uid,
            SEGMENT_NAME: 'All Games',
        }
        sendAnalytics('track', properties, 'Play Game', ['mixpanel', 'gtag'])
    }

    useEffect(() => {
        getAllCategoryId().then(res => {
            if (res && allCategory?.data?.length === 0) {
                fetchCategories(res)
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (allCategory) {
            setIsAllCategoriesLoading(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    const handleScrollForNotLoggedInUser = () =>
        setScrollHomepageForNotLoggedInUser(window.scrollY)
    const handleScrollForLoggedInUser = () =>
        setScrollHomePageForLoggedInUser(window.scrollY)

    useEffect(() => {
        if (!loginState.accessToken) {
            window.scrollTo(0, scrollHomepageForNotLoggedInUser)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [games, loginState])

    useEffect(() => {
        if (
            !games?.isLoading &&
            games?.data?.results?.length > 0 &&
            !loginState.accessToken
        ) {
            document.addEventListener(
                'scroll',
                handleScrollForNotLoggedInUser
            )
        }
        return () =>
            document.removeEventListener(
                'scroll',
                handleScrollForNotLoggedInUser
            )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [games, loginState])

    useEffect(() => {
        if (
            !games?.isLoading &&
            games?.data?.results?.length > 0 &&
            !!loginState.accessToken
        ) {
            document.addEventListener('scroll', handleScrollForLoggedInUser)
        }
        return () =>
            document.removeEventListener(
                'scroll',
                handleScrollForLoggedInUser
            )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [games, loginState])


    if(error){
        return <ErrorPage message={error} />
    }

    return (
        <div className={`${process.env.REACT_APP_THEME === "dark" ? "bg-black" : "bg-white"} relative`}>
            {process.env.REACT_APP_ENABLE_HEADER === "true" &&
                <header
                    className={`max-w-[960px] pt-[20px] mx-auto lg:px-0 px-2 flex items-start justify-between ${process.env.REACT_APP_THEME === "dark" ? "bg-black" : "bg-white"}`}>
                    {process.env.REACT_APP_BRAND_LOGO !== "TP" && <img
                        src={`/${process.env.REACT_APP_BRAND_LOGO}.png`}
                        alt="Brand Logo"
                        className="h-8 md:h-10 w-auto object-contain rounded-xl"
                    />}

                    {process.env.REACT_APP_BRAND_LOGO === "TP" && process.env.REACT_APP_THEME === "dark" &&
                        <a href={"https://timepass.app/yLpY/32natroq"} target={"_blank"}>
                            <img
                                src={`/logo-white.png`}
                                alt="Brand Logo"
                                className="h-8 md:h-10 w-auto object-contain rounded-xl"
                            />
                        </a>}
                    {process.env.REACT_APP_BRAND_LOGO === "TP" && process.env.REACT_APP_THEME === "light" &&
                        <a href={"https://timepass.app/yLpY/32natroq"} target={"_blank"}>
                            <img
                                src={`/logo-black.png`}
                                alt="Brand Logo"
                                className="h-8 md:h-10 w-auto object-contain rounded-xl"
                            />
                        </a>}
                    <Link to={`/search${access_token ? '?_portalToken=' + access_token : ''}`}>
                        <button
                            type="button"
                            className={` flex items-center justify-center p-2 rounded-full hover:scale-105
            ${
                                process.env.REACT_APP_THEME === 'light'
                                    ? 'bg-gray-700 hover:bg-black'
                                    : 'bg-gray-700 hover:bg-gray-800'

                            }
            transition`}
                            aria-label="Search"
                        >
                            <img
                                src="https://timepass.games/icons/search-icon.svg"
                                alt="Search"
                                className="w-5 h-5"
                                draggable="false"
                            />
                        </button>
                    </Link>
                </header>}

            <div
                id='gamecon'
                className='max-w-[960px] mx-auto px-2 relative'>
                {process.env.REACT_APP_ENABLE_HEADER === "false" &&
                    <Link to={`/search${access_token ? '?_portalToken=' + access_token : ''}`}>
                        <button
                            type="button"
                            className={`absolute right-[20px] top-[5px] md:top-[10px] flex items-center justify-center p-2 rounded-full hover:scale-105
            ${
                                process.env.REACT_APP_THEME === 'light'
                                    ? 'bg-gray-700 hover:bg-black'
                                    : 'bg-gray-700 hover:bg-gray-800'

                            }
            transition`}
                            aria-label="Search"
                        >
                            <img
                                src="https://timepass.games/icons/search-icon.svg"
                                alt="Search"
                                className="md:w-5 md:h-5 h-4 w-4"
                                draggable="false"
                            />
                        </button>
                    </Link>}
                {firstTimeLoading && (
                    <>
                        <div className='py-4'>
                        <Shimmer/>
                        </div>
                    </>
                )}
                {isAllCategoriesLoading ? (
                    <>
                        <div className='py-4'>
                            <Shimmer/>
                        </div>
                    </>
                ) : (
                    <>
                        <Helmet>
                            <title>{process.env.REACT_APP_TITLE}</title>
                            <meta
                                name='description'
                                content={process.env.REACT_APP_META_CONTENT}
                            />
                        </Helmet>
                        <div className='py-4'>
                            {continueGames?.length > 0 &&
                                <ContinuePlayingComponent
                                    accessToken={access_token}
                                    games={{
                                        name: "Continue Playing",
                                        games: continueGames,
                                    }}/>
                            }
                            {allCategory?.data?.map((data, index) => {
                                    if (data.results.name === "Top 10 Games") {
                                        return <div>
                                            {createElement(TopGames, {
                                                games: data?.results.games,
                                                accessToken: access_token
                                            })}
                                            <div>
                                                <Ad2/>
                                            </div>
                                        </div>
                                    }
                                return createElement(CategoryComponent, {
                                        index:index,
                                        key: data?.results?.uuid,
                                        games: data?.results,
                                        categoryId: data?.results?.uuid,
                                        totalpages: allCategory?.totalpages,
                                        fetchSingleCategory: fetchSingleCategory,
                                        handleAllGamesClicked: handleAllGamesClicked,
                                    accessToken: access_token
                                    })
                                }
                            )}
                        </div>
                    </>
                )}
            </div>
            {process.env.REACT_APP_ENABLE_FOOTER === "true" &&
                <TimepassInfoBanner/>
            }

        </div>
    )
}
export default Home
